import { FC, memo, useCallback } from 'react'
import { Button, Menu, MenuItem, Popover } from '@blueprintjs/core'
import { usePdfEditor } from './PdfEditorProvider'
import useCallbackDebounced from '../../../hooks/shared/useCallbackDebounced'
import Toolbar from 'polotno/toolbar/toolbar'
import Tooltip from '@mui/material/Tooltip'

const ContextToolbar: FC = () => {
  const { store, activeTextArea, insertMergeField } = usePdfEditor()
  const onMouseDownDefault = useCallback(
    (e: React.MouseEvent<HTMLElement, MouseEvent>) => e.preventDefault(),
    [],
  )
  const insertApplicantMergeField = useCallbackDebounced(() => {
    insertMergeField('{{recipient}}')
  }, [insertMergeField])
  const insertAddressMergeField = useCallbackDebounced(() => {
    insertMergeField('{{address}}')
  }, [insertMergeField])
  const insertPostcodeMergeField = useCallbackDebounced(() => {
    insertMergeField('{{postcode}}')
  }, [insertMergeField])
  return (
    <Toolbar
      store={store}
      components={{
        ...(activeTextArea && {
          ActionControls: () => (
            <Popover
              autoFocus={false}
              content={
                <Menu>
                  <MenuItem
                    text="recipient"
                    onMouseDown={onMouseDownDefault}
                    onClick={insertApplicantMergeField}
                  />
                  <MenuItem
                    text="address"
                    onMouseDown={onMouseDownDefault}
                    onClick={insertAddressMergeField}
                  />
                  <MenuItem
                    text="postcode"
                    onMouseDown={onMouseDownDefault}
                    onClick={insertPostcodeMergeField}
                  />
                </Menu>
              }
              placement="bottom"
            >
              <Tooltip title={'Add merge field'} placement="left">
                <Button intent="none" onMouseDown={onMouseDownDefault} icon="code" />
              </Tooltip>
            </Popover>
          ),
        }),
        FigureFilters: () => null,
        History: () => null,
        TextAiWrite: () => null,
        TextFilters: () => null,
        CopyStyle: () => null,
        Opacity: () => null,
        Duplicate: () => null,
        Remove: () => null,
        PageBackground: () => null,
        ImageFlip: () => null,
        ImageFitToBackground: () => null,
        ImageFilters: () => null,
        ImageCrop: () => null,
        ImageClip: () => null,
        ImageRemoveBackground: () => null,
        ImageAnimations: () => null,
      }}
    />
  )
}

export default memo(ContextToolbar)
